import CryptoJS from 'crypto-js'
import { getSignaturePrefix } from '../../../utils'

/**
 * 1. 生成动态签名 KEY
 */
export async function localhostGenSignatureKeyApi({
  baseUrl,
  port,
  timestamp,
  signaturePrefix,
  rd,
}: {
  baseUrl: string
  port: number
  timestamp: number
  signaturePrefix: string
  rd: string
}): Promise<any> {
  const url = `${baseUrl}:${port}/login/gen-signature-key?timestamp=${timestamp}&signature=${signaturePrefix}&rd=${rd}`

  const controller = new AbortController()
  const signal = controller.signal
  const timeoutId = setTimeout(() => {
    controller.abort()
  }, 1000)

  try {
    const response = await fetch(url, { method: 'GET', signal })
    clearTimeout(timeoutId)
    return await response.json()
  } catch (e) {
    clearTimeout(timeoutId)
    return null
  }
}

/**
 * 2. 检查登录状态
 */
export async function localhostCheckLoginStateApi({
  baseUrl,
  port,
  timestamp,
  signatureKey,
  rd,
}: {
  baseUrl: string
  port: number
  timestamp: number
  signatureKey: string
  rd: string
}): Promise<any> {
  const hmac = CryptoJS.HmacSHA256(String(timestamp), signatureKey)
  const signature = CryptoJS.enc.Hex.stringify(hmac)
  const signaturePrefix = signature.slice(0, 16)

  const url = `${baseUrl}:${port}/login/check-login-state?timestamp=${timestamp}&signature=${signaturePrefix}&rd=${rd}`

  const controller = new AbortController()
  const signal = controller.signal
  const timeoutId = setTimeout(() => {
    controller.abort()
  }, 1000)

  try {
    const response = await fetch(url, { method: 'GET', signal })
    clearTimeout(timeoutId)
    return await response.json()
  } catch (e) {
    clearTimeout(timeoutId)
    return null
  }
}

/**
 * 3. 获取授权 Code
 */
export async function localhostGetAuthorizeCodeApi({
  baseUrl,
  userid,
  port,
  timestamp,
  signatureKey,
  rd,
}: {
  baseUrl: string
  userid: number
  port: number
  timestamp: number
  signatureKey: string
  rd: string
}): Promise<any> {
  const signaturePrefix = getSignaturePrefix(String(timestamp), `${signatureKey}${userid}`)

  const body = { userid, timestamp, signature: signaturePrefix, rd }

  try {
    const response = await fetch(`${baseUrl}:${port}/login/authorize`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
    return await response.json()
  } catch (e) {
    return null
  }
}
